import { store } from '@betacrew/jars-flux';

export const componentKey = "TIPALTI_SWITCH";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setPayersList: (state, action) => {
            state.payersList = action.payload;
        },
        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },
        setTipaltiRedirectUrl: (state, action) => {
            state.tipaltiRedirectUrl = action.payload;
        },
        setBusinessNameList: (state, action) => {
            state.businessNameList = action.payload;
        },
        setFormAndTaxYearList: (state, action) => {
            state.formAndTaxYearList = action.payload;
        },
        setPayerEntityFilters: (state, action) => {
            state.payerEntityFilters = action.payload;
        },
        setIsPaymentNotMapped: (state, action) => {
            state.isPaymentNotMapped = action.payload;
        },
        setUploadedFilePath: (state, action) => {
            state.uploadedFilePath = action.payload;
        },
        setImportData: (state, action) => {
            state.importData = action.payload;
        },
        setIsImportDataGridViewLoaded: (state, action) => {
            state.isImportDataGridViewLoaded = action.payload;
        },
        setFormBoxLabels: (state, action) => {
            state.formBoxLabels = action.payload;
        },
        setFormSettings: (state, action) => {
            state.formSettings = action.payload;
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
    },
    initialReducerState: {
        payersList: [],
        selectedPayer: {},
        tipaltiRedirectUrl: "",
        businessNameList: [],
        formAndTaxYearList: {},
        payerEntityFilters: [],
        isPaymentNotMapped: false,
        uploadedFilePath: '',
        importData: null,
        isImportDataGridViewLoaded: false,
        formBoxLabels: [],
        formSettings: null,
        loadingState: false
    }
});

export const { setPayersList, setSelectedPayer, setTipaltiRedirectUrl, setBusinessNameList, setFormAndTaxYearList,
    setPayerEntityFilters, setIsPaymentNotMapped, setUploadedFilePath, setImportData, setIsImportDataGridViewLoaded,
    setFormBoxLabels, setFormSettings, setLoadingState } = actions;